<template>
  <div :class="{'editor-container': isMenuMiniSize, 'editor-container-thin-menu': !isMenuMiniSize}">
    <div class="editor-box flex-vertical-left">
      <div class="editor-box-child">
        <div class="menu-title">
          <p style="padding: 8px; border: solid thin #AA0066;">ページ編集画面</p>
        </div>
        <div class="child-box">
          <div>
            <p style="font-size: 12px; margin-bottom: 8px;">現在の公開設定</p>
            <p v-if="selectContent.is_public"><span class="mdi mdi-link-variant" style="margin-right: 8px;"></span>{{getPublic(selectContent.is_public)}}</p>
            <p v-else><span class="mdi mdi-link-variant" style="margin-right: 8px;"></span>{{getPublic(selectContent.is_public)}}</p>
          </div>
        </div>
        <a class="child-box menu-button" @click="updateContent()" v-if="selectContent.contents_id !== 'new'">
          <span class="mdi mdi-content-save"     style="margin-right: 8px;" v-if="!isSaveContentsLoading"></span>
          <span class="mdi mdi-loading mdi-spin" style="margin-right: 8px;" v-if="isSaveContentsLoading"></span>
          保存
        </a>
        <a class="child-box menu-button" @click="saveCustomContent()" v-if="selectContent.contents_id == 'new'">
          <span class="mdi mdi-content-save"     style="margin-right: 8px;" v-if="!isSaveContentsLoading"></span>
          <span class="mdi mdi-loading mdi-spin" style="margin-right: 8px;" v-if="isSaveContentsLoading"></span>
          保存
        </a>
        <a class="child-box menu-button" @click="previewDemo(selectContent)">
          <span class="mdi mdi-play" style="margin-right: 8px;"></span>プレビュー
        </a>
        <a class="child-box menu-button" @click="selectContent.is_public=true;updateContent()" v-if="!selectContent.is_public">
          <span class="mdi mdi-link-variant" style="margin-right: 8px;"></span>ページを<br>公開
        </a>
        <a class="child-box menu-button" @click="selectContent.is_public=false;updateContent()" v-else>
          <span class="mdi mdi-link-variant" style="margin-right: 8px;"></span>ページを<br>非公開
        </a>
        <a class="child-box menu-button" @click="backMenu()">
          <span class="mdi mdi-undo" style="margin-right: 8px;"></span>
          戻る
        </a>
      </div>
    </div>
    <div class="editor-box flex-vertical-right">
      <div class="editor-box-main" v-if="this.selectContent.contents_id != null">
        <MainTitle   :isMobile="false" :isView="false" v-if="selectContent.layout===0"/>
        <MainAbout   :isMobile="false" :isView="false" v-if="selectContent.layout===1"/>
        <MainMessage :isMobile="false" :isView="false" v-if="selectContent.layout===2"/>
        <MainInfo    :isMobile="false" :isView="false" v-if="selectContent.layout===3"/>
        <MainRecruit
          :isMobile="false"
          :isView="false"
          @top-selected-change="updateTopDepartment"
          @second-selected-change="updateSecondDepartment"
          @third-selected-change="updateThirdDepartment"
          v-if="selectContent.layout===4"
        />
        <MainCustom  :isMobile="false" :isView="false" :id="selectContent.contents_id" v-if="selectContent.layout===5"/>
      </div>
      <div class="editor-box-main" v-else>
        <div>
          <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MainTitle    from '@/views/DashBoard/EmploymentPage/MainTitle'
import MainAbout    from '@/views/DashBoard/EmploymentPage/MainAbout'
import MainMessage  from '@/views/DashBoard/EmploymentPage/MainMessage'
import MainInfo     from '@/views/DashBoard/EmploymentPage/MainInfo'
import MainRecruit  from '@/views/DashBoard/EmploymentPage/MainRecruit'
import MainCustom   from '@/views/DashBoard/EmploymentPage/MainCustom'
export default {
  name: 'EmploymentPageEditor',
  componentName: 'EmploymentPageEditor',
  components: {
    MainTitle,
    MainAbout,
    MainMessage,
    MainInfo,
    MainRecruit,
    MainCustom
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('employmentPage', ['contents', 'selectContent', 'isSaveContentsLoading']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  data() {
    return {
      // 組織情報
      topDepartment: null,
      secondDepartment: null,
      thirdDepartment: null,
    }
  },
  mounted () {
    console.debug('*** Start *** moveToEditorCreateCustom')
    this.$store.dispatch('employmentPage/getContentsList', {pages: this.$route.query.pages, isRecruitPage: this.$route.query.recruit, userHash: this.user.userHash})
    if (this.selectContent.content_id == 'new' && this.selectContent.layout == 0) {
      var newContent = {
        contents_id: 'new',
        layout: 5,
        title: 'no title',
        is_main: false,
        content: {
          layout_type: 5,
          list: []
        }
      }
      this.$store.dispatch('employmentPage/setEditContentCustom', newContent)
        .then(() => this.$router.push('/dashboard/employment/editor/new'))
    }
  },
  watch: {
    isSaveContentsLoading () {
      if (!this.isSaveContentsLoading) this.saveAlert()
    },
    contents () {
      for (var i in this.contents) {
        if (this.contents[i].contents_id == this.$route.params.content_id) {
          this.$store.dispatch('employmentPage/setEditContent', this.contents[i])
        }
      }
    }
  },
  methods: {
    previewDemo (c) {
      console.debug('*** Start *** preview')
      console.debug('c: ' + JSON.stringify(c))
      var url = ''
      if (this.$route.query.recruit == 'true') {
        url = process.env.LOC_HOST + '/recruit/demo/' + this.user.companyID + '/' + c.contents_id
      } else {
        url = process.env.LOC_HOST + '/cstm/demo/' + this.user.companyID + '/' + c.contents_id
      }
      var h = window.outerHeight
      var w = window.outerWidth / 2
      window.open(url, '_blank', 'width=' + w + 'px, height=' + h + 'px, left=0, top=0, directories=no, status=no, menubar=no, scrollbars=yes, location=no, toolbar=no')
      console.debug('*** End *** preview')
    },
    // 変更内容の保存
    updateContent () {
      let updateData = this.selectContent
      // 組織情報の選択状況反映
      updateData.top_department = this.topDepartment
      updateData.second_department = this.secondDepartment
      updateData.third_department = this.thirdDepartment
      this.$store.dispatch('employmentPage/putContents',
        {
          content: updateData,
          pages: this.$route.query.pages ? this.$route.query.pages : 1
        }
      )
    },
    // 親組織情報変更メソッド
    updateTopDepartment(selectedValue) {
      this.topDepartment = selectedValue
      // 子組織と孫組織を初期化する
      this.secondDepartment = null
      this.thirdDepartment = null
    },
    // 子組織情報変更メソッド
    updateSecondDepartment(selectedValue) {
      this.secondDepartment = selectedValue
      // 孫組織を初期化する
      this.thirdDepartment = null
    },
    // 孫組織情報変更メソッド
    updateThirdDepartment(selectedValue) {
      this.thirdDepartment = selectedValue
    },
    saveCustomContent () {
      var image_data = ''
      if (this.selectContent.is_image_original) {
        image_data = this.selectContent.image.replace(/^.*,/, '')
      } else if (this.selectContent.image_unsplash) {
        image_data = this.selectContent.image_unsplash
      }
      var setJson = {
        title: this.selectContent.title,
        content: this.selectContent.content,
        is_image_original: this.selectContent.is_image_original,
        image_data: image_data
      }
      this.$store.dispatch('employmentPage/postContentsRecruit', {content: setJson, pages: this.$route.query.pages ? this.$route.query.pages : 1, layout: 5})
      this.saveAlert()
      this.$router.push('/dashboard/employment/list?pages=1&recruit=false')
    },
    saveAlert () {
      console.debug('*** Start *** saveAlert')
      this.$buefy.snackbar.open({
        message: '保存しました！',
        type: 'is-primary',
        position: 'is-top',
        indefinite: true
      })
      console.debug('*** End *** saveAlert')
    },
    backMenu () {
      console.debug('*** Start *** backMenu')
      this.$router.push('/dashboard/employment/list?pages=' + this.$route.query.pages + '&recruit=' + this.$route.query.recruit)
      console.debug('*** End *** backMenu')
    },
    getPublic (flg) {
      console.debug('*** Start *** getPublic')
      console.log('Set Calendar: ' + JSON.stringify(flg))
      if (flg) return '公開'
      else return '非公開'
    }
  }
}
</script>

<style scoped>
.header-pc {
  width: 100%;
  height: 24px;
  background: #B55;
  color: white;
}
.header-mobile {
  width: 100%;
  background: #B55;
  color: white;
}
.editor-container {
  height: 100vh;
  width: 100%;
  background: #FEFEFE;
  display: flex;
}
.editor-container-thin-menu {
  height: 100vh;
  width: 100%;
  background: #FEFEFE;
  display: flex;
}
.editor-box {
  width: 100%;
  background: white;
  border: solid thin #ddd;
}
.flex-vertical-left {
  border: none;
  width: 160px;
  height: 100%;
  overflow-y: scroll;
  background-color: rgb(55, 55, 55) !important;
  color: white;
}
.editor-box-header {
  border: solid thin #ddd;
  box-sizing: border-box;
  height: 0%;
  background: white;
}
.editor-box-main {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  background: white;
  overflow-y: scroll;
}
.editor-box-main::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}

.flex-vertical-right {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #FEFEFE;
  border: none;
  width: 100%;
}
.editor-box-sub {
  border: solid thin #ddd;
  box-sizing: border-box;
  height: 75%;
  background: white;
  overflow-y: scroll;
}
.editor-box-child {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.child-box {
  display: flex;
  justify-content: center;
  align-items: center;
  border: solid thin #AA0066;
  width: calc(100% - 16px);
  margin: 4px 8px;
  height: 72px;
  font-size: 14px;
}
.menu-button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FF99EE;
  font-size: 14px;
  transition: 0.5s;
}
.menu-button:hover {
  color: white;
  background: #AA0066;
}
.menu-title {
  padding: 8px;
  width: 100%;
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/EmploymentPage/EmploymentPageEditor.vue